<template>
  <div class="finance-index">
    <div class="survey" v-for="(item, index) in survey" :key="index">
      <h2 class="title">{{item.title}}</h2>
      <ul>
        <el-row>
          <el-col v-for="(dataItem, dataIndex) in item.data" :key="dataIndex" :xs="24" :sm="12" :md="12" :lg="7" :xl="6">
            <li class="dataItem">
              <img :src="dataItem.src" class="dataItem-img">
              <div class="dataItem-content">
                <p class="dataItem-title">{{dataItem.title}}</p>
                <p class="dataItem-value">{{dataItem.value}}</p>
              </div>
              <el-divider v-if="(item.data.length - 1) != dataIndex" direction="vertical"></el-divider>
            </li>
          </el-col>
        </el-row>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "FIndex",
  data() {
    return {
      survey: [{
        title: '订单概况',
        data: [{
          title: '本月订单额',
          src: require("@/assets/finance_images/finance_7.png"),
          value: '3486,78',
          company: '元'
        },{
          title: '订单总金额',
          src: require("@/assets/finance_images/finance_1.png"),
          value: '400000，00',
          company: '元'
        },{
          title: '订单总数',
          src: require("@/assets/finance_images/finance_2.png"),
          value: '3678',
          company: '个'
        },{
          title: '退款订单总额',
          src: require("@/assets/finance_images/finance_3.png"),
          value: '368',
          company: '元'
        },{
          title: '退款订单总数',
          src: require("@/assets/finance_images/finance_4.png"),
          value: '2',
          company: '个'
        }]
      },{
        title: '会员概况',
        data: [{
          title: '会员数量',
          src: require("@/assets/finance_images/finance_5.png"),
          value: '1134,5',
          company: '元'
        },{
          title: '会员本周新增',
          src: require("@/assets/finance_images/finance_6.png"),
          value: '298',
          company: '个'
        }]
      }]
    };
  },
  created () {
  },
  methods: {
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.finance-index {
  padding: 15px 20px 20px 20px;
  .survey{
    &:last-child{
      border: 0;
    }
    border-bottom: 1px solid #ccc;
    .title{
      font-size: 20px;
      font-weight: 600;
      color: #333333;
      line-height: 68px;
      border-bottom: 1px solid #ccc;
      margin: 0;
    }
    ul{
      margin: 0;
      padding: 0;
      // display: flex;
      // flex-wrap: wrap;
      li{
        margin: 0;
        padding: 0;
        list-style: none;
        // width: 345px;
        height: 150px;
        display: flex;
        align-items: center;
        padding-left: 50px;
        img{
          width: 56px;
          height: 56px;
        }
        .dataItem-content{
          margin-left: 20px;
          width: 194px;
          .dataItem-title{
            font-size: 14px;
            color: #666666;
            margin: 0;
            margin-bottom: 10px;
          }
          .dataItem-value{
            font-size: 28px;
            font-weight: 600;
            color: #333333;
            margin: 0;
            span{
              font-size: 14px;
              font-weight: 400;
              color: #666666;
              margin-left: 10px;
            }
          }
        }
        ::v-deep{
          .el-divider--vertical{
            height: 100px;
          }
          .el-col{
            display: flex;
            flex-wrap: wrap;
          }
        }
      }
    }
  }
}
</style>
